import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { API_ALARM_CONFIGURATION_URL, API_ALARM_URL } from '../../core.global';
import { BasicService } from '../../_base/services/basic.service';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

/** Estado de un tipo de alarma para un equipo, según `GET /alarm/configuration/device`. */
export type AlarmConfigurationStatus = 'configured' | 'unassigned' | 'missing';

export interface AlarmConfigurationEntry {
    id: number;
    alarm_message: string | null;
    alarm_th: number | null;
    time_between_alarms: number | null;
    sensors: { id: number; name: string }[];
}

export interface AlarmConfigurationType {
    id: number;
    name: string;
    status: AlarmConfigurationStatus;
    configs: AlarmConfigurationEntry[];
}

export interface DeviceAlarmConfiguration {
    device: {
        id: number;
        description: string | null;
        location_id: number | null;
        position_alarm_threshold_m: number | null;
        altitude_alarm_threshold_m: number | null;
        mag_alarm_threshold: number | null;
        mag_angle_threshold: number | null;
        accel_angle_threshold: number | null;
    };
    types: AlarmConfigurationType[];
    configured_count: number;
}

@Injectable()
export class AlarmService extends BasicService{
    baseUrl:string = '';

    alarms$ = new BehaviorSubject(null);
    
    constructor(protected http: HttpClient){
        super(http);
        this.baseUrl = API_ALARM_URL;
    }

    takeDecision(alarm, alarmAction, comment, commentType): Observable<any>{
        return this.http.put(`${this.baseUrl}/decision/${alarm.id}`, {
            id: alarm.id, 
            alarm_action_id: alarmAction.id,
            user_comment: comment,
            comment_type_id: commentType.id
        })
    }

    /** Cruce entre los tipos de alarma y las configuraciones del dispositivo. */
    getDeviceConfiguration(deviceId: number): Observable<DeviceAlarmConfiguration> {
        const params = new HttpParams().set('device_id', String(deviceId));
        return this.http.get<any>(`${API_ALARM_CONFIGURATION_URL}/device`, { params }).pipe(
            map(response => response.item)
        );
    }

    setAlarms(alarms){
        this.alarms$.next(alarms);
    }
}